
import { useNavigate } from 'react-router-dom';
import Button from '../base/Button';

export default function HeroSection() {
  const navigate = useNavigate();
  
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Modern%20financial%20technology%20workspace%20with%20clean%20minimalist%20design%2C%20professional%20business%20environment%2C%20soft%20natural%20lighting%2C%20contemporary%20office%20setup%20with%20financial%20charts%20and%20graphs%20on%20screens%2C%20clean%20white%20and%20green%20color%20scheme%2C%20professional%20atmosphere%2C%20high-tech%20financial%20planning%20tools%2C%20organized%20desk%20with%20laptop%20and%20documents%2C%20inspiring%20and%20trustworthy%20ambiance&width=1920&height=1080&seq=hero-invirtiendo&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Ahorrar, invertir y 
              <span className="text-emerald-400"> crecer con inteligencia</span>
            </h1>
            <p className="text-xl mb-8 text-gray-200 leading-relaxed">
              La plataforma que revoluciona tu gestión financiera. Visualiza tus ingresos y gastos, 
              procesa automáticamente tus resúmenes bancarios con IA y toma decisiones inteligentes 
              para construir tu futuro económico.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="text-lg px-8 py-4"
                onClick={() => navigate('/plans')}
              >
                <i className="ri-rocket-line mr-2"></i>
                Empezar Gratis
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-gray-900"
                onClick={() => navigate('/login')}
              >
                <i className="ri-play-circle-line mr-2"></i>
                Ver Demo
              </Button>
            </div>
          </div>
          
          <div className="hidden lg:block">
            {/* El espacio para la imagen está manejado por el background */}
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
